module.exports = __webpack_public_path__ + "static/media/infoJumbo1.07426f5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aalbers/images/infoJumbo1.jpg
// module id = 567
// module chunks = 0